module.exports = __webpack_public_path__ + "static/media/floriel-logo.4e670138.png";